import React, { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import AppLoading from "@/components/AppLoading";

export default function EntraCallback() {
  const auth = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function handleCallback() {
      try {
        const success = await auth.handleEntraCallback();
        if (cancelled) return;

        if (success) {
          const redirectUri = sessionStorage.getItem("redirectUri") || "/";
          window.location.replace(redirectUri);
        } else {
          setError("Login failed. Please try again.");
        }
      } catch (err: any) {
        if (cancelled) return;
        console.error("[EntraCallback] Error:", err);
        setError(err?.message || "Login failed. Please try again.");
      }
    }

    handleCallback();

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
          <div className="text-red-500 text-xl mb-4">Login Failed</div>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => window.location.replace("/")}
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return <AppLoading />;
}
